import { Education, Training } from '~/types';
import { DashAcademicResponse, DashboardAcademics } from './types';

export const eduApiToDashAcademics = (educationStr: string): DashAcademicResponse => {
  const response: Education[] = JSON.parse(educationStr);
  return {
    data: response.map((data: Education) =>
      eduToDashAcademic(JSON.stringify(data))
    ) as DashboardAcademics[],
  };
};

const degreeToLabel = (degree: unknown): string => {
  if (!degree) return '';
  if (typeof degree === 'string') return degree;
  if (typeof degree === 'object' && 'label' in degree) {
    return String((degree as { label: unknown }).label ?? '');
  }
  return '';
};

export const eduToDashAcademic = (data: string): DashboardAcademics => {
  const education: Education = JSON.parse(data);
  return {
    id: education.id,
    schoolName: education.institution?.name ?? education.institutionName ?? '',
    degreeName: degreeToLabel(education.degree),
    gradDate: education.endDate || 'Incomplete',
    keyPrefix: 'EDU-',
  };
};

export const trainingApiToDashboardAcademics = (licensesStr: string): DashAcademicResponse => {
  const response: Training[] = JSON.parse(licensesStr);
  return {
    data: response.map((license) =>
      trainingToDashboardAcademic(JSON.stringify(license))
    ) as DashboardAcademics[],
  };
};

export const trainingToDashboardAcademic = (trainingString: string): DashboardAcademics => {
  const training: Training = JSON.parse(trainingString);
  return {
    id: training.id,
    schoolName: training.facility?.name ?? training.facilityName ?? '',
    degreeName: training.trainingType,
    gradDate: training.endDate || 'Incomplete',
    keyPrefix: 'TRN-',
  };
};
